module.exports = "/wwwroot/img/water_supply_break_notice_page.png?ver=9b898044";